import { acriOnboardingABTestRouteConfig } from '@/config/abTestConfig'
import { saveAnswer } from '@/utils/onboardingStorage'
import { navigateToNextOnboardingPage } from '@app-studio-web/ui/helpers/abTestRouting'
import { getABTestVariantFromContext } from '@app-studio-web/ui/helpers/variantContext'

function normalizeValue(value: FormDataEntryValue) {
  return String(value)
}

export default async function navigateToNextOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  const formData = await request.formData()
  const entries = Array.from(formData.entries())

  if (entries.length > 0) {
    const [question, firstValue] = entries[0]
    const values = formData.getAll(question).map(normalizeValue)
    const answerValue =
      values.length > 1 ? values.join(', ') : normalizeValue(firstValue)
    const path =
      new URL(request.url).pathname.split('/').filter(Boolean).pop() || 'root'

    saveAnswer(path, {
      question_key: path,
      question: question || path,
      answer_key: values[0] || answerValue,
      answer: answerValue,
    })
  }

  const variant = getABTestVariantFromContext()

  return navigateToNextOnboardingPage({
    request,
    routeConfig: acriOnboardingABTestRouteConfig,
    variant,
    redirectOnComplete: '/sign-up/company',
  })
}
